import { createAsyncThunk } from '@reduxjs/toolkit'
import { DashboarInfodVo } from 'vo/Dashboard'
import { FetchQueryOptions } from '@tanstack/react-query'

import { DashboardCategory } from './types'
import * as API from '../../api'

export const getDashboardInfos = createAsyncThunk(
  'dashboard/getDashboardInfos',
  async ({ category, options }: { category?: DashboardCategory; options?: FetchQueryOptions }) => {
    const { data } = await API.getDashboardInfos(category, options)
    const transformedData = data.map((d: any) => DashboarInfodVo(d))
    return transformedData
  }
)

export const getRecentViewedDashboardInfos = createAsyncThunk(
  'dashboard/getRecentViewedDashboardInfos',
  async (options?: FetchQueryOptions) => {
    const { data } = await API.getRecentViewedDashboardInfos(options)
    const transformedData = data.map((d: any) => DashboarInfodVo(d))
    return transformedData
  }
)
